<template>
<el-dialog class="acceptProposal" :visible.sync="dialogVisible" top="0" :before-close="closeModal" width="569px">
    <div class="w-100">
        <div class="pt-2 px-2 mt-5">
            <div class="d-flex justify-content-center mb-2">
                <AlertExclamationRegister />
            </div>
            <h3 class="c-ndarkthree bold mb-2 text-center">
                CNPJ não vinculado a um cliente cadastrado
            </h3>
            <p class="c-ndarkfour text-center">
                Verificamos que o CNPJ informado não está associado a <br>
                nenhum cliente em nosso sistema. Se tiver dúvidas, entre em contato com <br>
                o suporte para saber como prosseguir com seu cadastro.
            </p>
        </div>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <Button @click="closeModal" :color="getPrimaryColor">
            Fechar
        </Button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    components: {
        AlertExclamationRegister,
    },
    methods: {
        closeModal() {
            window.location.href = `${this.getServiceUrls.CLIENT}/`
        }
    }

}
</script>

<style lang="scss">
</style>